import { render } from "./user-simple.vue?vue&type=template&id=65f9e728"
import script from "./user-simple.vue?vue&type=script&lang=js"
export * from "./user-simple.vue?vue&type=script&lang=js"

import "./user-simple.vue?vue&type=style&index=0&id=65f9e728&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__